export default Object.freeze({
  Global: 1,
  Scoped: 2,
});
